export enum AccessMode {
    EDIT = 1,
    CREATE = 2,
    DISPLAY = 3
}
